import axiosInstance from "../config/axios/axios.config";

export const metaData = () => {
  return axiosInstance.get("/accounts/user-meta-data/");
};
